import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import styles from "assets/jss/default/components/inspectionDetailStyle";
import newCaseWithDiagnosticDialogStyle from "assets/jss/default/components/newCaseWithDiagnosticDialogStyle";
import Grid from "@mui/material/Grid";
import { useFormAutoValidation } from "hooks/useFormValidation";
import * as yup from "yup";
import { TextField } from "components/TextField";
import cx from "classnames";

const useStyles = makeStyles({
  ...styles,
  summaryFieldsSection: newCaseWithDiagnosticDialogStyle.summaryFieldsSection
});
const validationSchema = yup.object().shape({
  description: yup
    .string()
    .label("Description")
    .required()
    .nullable(),
  recommendation: yup
    .string()
    .label("Recommendation")
    .nullable(),
  params: yup.object().shape()
});

function ReportDetailsForm({ eventModel, onFormChange }) {
  const classes = useStyles();
  const formik = useFormAutoValidation(
    eventModel,
    onFormChange,
    validationSchema,
    false
  );

  return (
    <Grid container direction="row" alignItems="flex-start">
      <Grid item xs={12} md={12} className={classes.summaryFieldsSection}>
        <TextField
          id="description"
          name="description"
          label="Description"
          required
          value={formik.values.description}
          fullWidth
          error={
            formik.touched.description && Boolean(formik.errors.description)
          }
          helperText={formik.touched.description && formik.errors.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          data-qa="CP-Text-Report-Description"
        />
      </Grid>
      <Grid
        item
        className={cx([classes.verticalGap16, classes.summaryFieldsSection])}
        xs={12}
      >
        <TextField
          id="recommendation"
          name="recommendation"
          label="Recommendation"
          value={formik.values?.recommendation ?? ""}
          fullWidth
          error={
            formik.touched?.recommendation &&
            Boolean(formik.errors?.recommendation)
          }
          helperText={
            formik.touched?.recommendation && formik.errors.recommendation
          }
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          data-qa="CP-Text-Report-Recommendation"
        />
      </Grid>
    </Grid>
  );
}

ReportDetailsForm.propTypes = {
  eventModel: PropTypes.object,
  onFormChange: PropTypes.func.isRequired
};

export default ReportDetailsForm;
